import { gql } from '@apollo/client';

export const GENERATE_STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILE_URL = gql`
  mutation generateStandardDeliveryDeviceHigherCategoryReportFileUrl(
    $reportData: StandardDeliveryDeviceHigherCategoryReportFileUrlInput!
    $sortOptions: SortOptions
    $searchTerm: String
  ) {
    generateStandardDeliveryDeviceHigherCategoryReportFileUrl(
      reportData: $reportData
      sortOptions: $sortOptions
      searchTerm: $searchTerm
    )
  }
`;
